<template>
    <div class="grid grid--padding">
        <div class="budget">
            <overview-layout :items="savedMaterials">
                <template #header>
                    <h2 class="budget__title">{{ $t('game-budget.title') }}</h2>
                    <p class="budget__desc">{{ $t('game-budget.description')  }}</p>
                </template>

                <template #footer>
                    <ul class="price-list">
                        <li class="price-list__item">
                            <span>{{ $t('game.text.initial-budget') }}</span>
                            <span>{{ formatPrice(initialBudget) }}</span>
                        </li>
                        <li class="price-list__item">
                            <span>{{ $t('game.text.spent-budget') }}</span>
                            <span>{{ formatPrice(spentBudget) }}</span>
                        </li>
                        <li class="price-list__item price-list__item--highlighted">
                            <span>{{ $t('game.text.remaining-budget') }}</span>
                            <span class="price-list__price">{{ formatPrice(remainingBudget) }}</span>
                        </li>
                    </ul>

                    <router-link :to="{name: 'game'}" class="btn btn--default">
                        {{ $t('button.back') }}
                    </router-link>
                </template>
            </overview-layout>
        </div>
    </div>
</template>

<script>
import OverviewLayout from '@/components/game/OverviewLayout.vue';

export default {
    name: 'GameBudgetView',
    components: {
        OverviewLayout
    },
    computed: {
        savedMaterials() {
            return this.$store.getters['game/getSavedMaterials'];
        },
        surfaceArea() {
            return this.$store.getters['game/getSurfaceArea'];
        },
        budgetCurrency() {
            return this.$store.getters['game/getBudgetCurrency'];
        },
        initialBudget() {
            return this.$store.getters['game/getInitalBudgetAmout'];
        },
        budgetAmount() {
            return this.$store.getters['game/getBudgetAmount'];
        },
        spentBudget() {
            let spent = parseInt(this.initialBudget) - parseInt(this.budgetAmount);

            return spent;
        },
        remainingBudget() {
            return this.initialBudget - this.spentBudget;
        }
    },
    methods: {
        formatPrice(price) {
            return `${Number(price).toLocaleString('hr')} ${this.budgetCurrency}`;
        }
    },
    beforeRouteLeave(to, _from, next) {
        const phase = this.savedMaterials.findIndex(material => material.id == to.params.phaseId);

        if (to.name == 'game-menu') {
            this.$store.commit('game/updatePhase', phase);
        }
        
        next();
    }
}
</script>
